import { toPersianNum } from "../../assets/utils";
import { CarPlateStyled } from "./carPlate.styles";

const CarPlate = ({
  plate = {
    threedigit: "",
    twodigit: "",
    alphabet_id: "test",
    location_id: "",
  },
}) => {
  return (
    <CarPlateStyled>
      <div>{toPersianNum(plate.location_id)}</div>
      <div>{toPersianNum(plate.threedigit)}</div>
      <div>{plate.alphabet_id}</div>
      <div>{toPersianNum(plate.twodigit)}</div>
    </CarPlateStyled>
  );
};
export default CarPlate;
